// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderView_header__2Ynva","logo":"HeaderView_logo__2urPF","right":"HeaderView_right__144D4","localeWrapper":"HeaderView_localeWrapper__2O7dC"};